import { createContext, MutableRefObject } from 'react';
import { ErrorDetails } from '@empiriecom/module-components/hooks/useFetch';
import { Rating } from '@/interfaces/Rating';
import { SeoDataInterface, Product } from '@/interfaces';
import { BreadcrumbData } from '@empiriecom/module-components/Breadcrumb/types';
import { InputError } from '../ProductSelection/Input/types';

export type DataContextType = {
  categoryData: {
    /** category from url (nav-c) or defaultCategory from product data */
    category: string;
    /** query from url (nav-q) */
    query?: string;
  };
  productData: {
    error: ErrorDetails;
    isLoading: boolean;
    product: Product | undefined;
    currentProductId: string;
    printProductId: string | undefined;
    setIsFallback: (isFallback: boolean) => void;
  };
  basketData: {
    /* quantity */
    quantity: number;
    setQuantity: (quantity: number) => void;
    /* article services */
    services: string[];
    addService: (uuid: string) => void;
    removeService: (uuid: string) => void;
    resetServices: () => void;
    /** ATB Modal stuff */
    addToBasketRequested: boolean;
    setAddToBasketRequested: (isRequested: boolean) => void;
    requestedSKU: string;
    setRequestedSKU: (sku: string) => void;
  };
  madeToMeasureData: {
    engraving: string;
    engravingError: string;
    length: number;
    lengthError: InputError;
    lengthInputRef: MutableRefObject<HTMLInputElement>;
    setEngraving: (engraving: string) => void;
    setEngravingError: (error: string) => void;
    setLengthError: (error: InputError) => void;
    setLengthInputRef: (ref: MutableRefObject<HTMLInputElement>) => void;
    setShowEngravingError: (showError: boolean) => void;
    setWidthError: (error: InputError) => void;
    setWidthInputRef: (ref: MutableRefObject<HTMLInputElement>) => void;
    showEngravingError: boolean;
    width: number;
    widthError: InputError;
    widthInputRef: MutableRefObject<HTMLInputElement>;
  };
  ratingData: {
    error: ErrorDetails;
    isLoading: boolean;
    rating: Rating | undefined;
  };
  seoData: {
    error: ErrorDetails;
    isLoading: boolean;
    seoData: SeoDataInterface | undefined;
  };
  breadcrumbData: {
    isLoading: boolean;
    error: Error;
    breadcrumb: BreadcrumbData;
  };
  pageData: {
    isBot: boolean;
  };
};

export const DataContext = createContext<DataContextType>(null);

export default DataContext;
